import App from '@/views/constants/app';

import Employee from '@/resources/models/employees';
import { EmploymentRelationship, EmploymentRelationshipDetail } from '@/resources/models/employment-relationships';

import NewEmployee from '@/views/constants/employee-new';
import NewEmployeePersonalValidator from '@/views/validations/employee-new-personal';
import NewEmployeeRelationshipValidator from '@/views/validations/employee-new-relationship';
import NewEmployeeDetailValidator from '@/views/validations/employee-new-detail';

import Employees from '@/views/constants/employees';
import EmployeesResource from '@/resources/constants/employees';
import { PolicyParticipation, PolicyParticipationDetail } from '../../../resources/models/policy-participations';

const state = {
  newEmployee: new Employee(),
  newEmployeeEmploymentRelationship: new EmploymentRelationship(),
  newEmployeeEmploymentRelationshipDetail: new EmploymentRelationshipDetail({ noRisk: false }),
  newEmployeePolicyParticipations: []
};

const getters = {
  newEmployee: state => state.newEmployee,
  newEmployeeEmploymentRelationship: state => state.newEmployeeEmploymentRelationship,
  newEmployeeEmploymentRelationshipDetail: state => state.newEmployeeEmploymentRelationshipDetail,

  newEmployeeValidations: state => NewEmployeePersonalValidator.validate(state.newEmployee),
  newEmployeeRequiredFields: state => NewEmployeePersonalValidator.requiredFields(state.newEmployee),

  newEmployeeEmploymentRelationshipValidations: state => NewEmployeeRelationshipValidator.validate(state.newEmployeeEmploymentRelationship),
  newEmployeeEmploymentRelationshipRequiredFields: state => NewEmployeeRelationshipValidator.requiredFields(state.newEmployeeEmploymentRelationship),

  newEmployeeEmploymentRelationshipDetailValidations: state => NewEmployeeDetailValidator.validate(state.newEmployeeEmploymentRelationshipDetail),
  newEmployeeEmploymentRelationshipDetailRequiredFields: state => NewEmployeeDetailValidator.requiredFields(state.newEmployeeEmploymentRelationshipDetail),

  newEmployeePolicyParticipations: state => state.newEmployeePolicyParticipations
};

const actions = {
  [NewEmployee.Actions.Form.EMPLOYEE_CHANGE] ({ commit }, data) {
    commit(NewEmployee.Mutations.Form.EMPLOYEE_CHANGE, data);
  },

  [NewEmployee.Actions.Form.RELATIONSHIP_CHANGE] ({ commit, rootGetters }, data) {
    commit(NewEmployee.Mutations.Form.RELATIONSHIP_CHANGE, data);
  },

  [NewEmployee.Actions.Form.DETAIL_CHANGE] ({ commit }, data) {
    commit(NewEmployee.Mutations.Form.DETAIL_CHANGE, data);
  },

  [NewEmployee.Actions.Cancel.DO] ({ commit }) {
    commit(NewEmployee.Mutations.CLEAR);
  },

  [Employees.Actions.Tabs.CLOSE] ({ commit }, tab) {
    if (tab.component === 'NewEmployee') {
      commit(NewEmployee.Mutations.CLEAR);
    }
  },

  [EmployeesResource.Actions.Create.SUCCESS] ({ commit }) {
    commit(NewEmployee.Mutations.CLEAR);
  },

  [NewEmployee.Actions.Navigate.DO] ({ commit, rootGetters }, view) {
    if (view === NewEmployee.Views.Confirmation) {
      commit(NewEmployee.Mutations.SET_POLICY_PARTICIPATIONS, {
        policies: rootGetters.policies
      });
    }
  }
};

const mutations = {
  [NewEmployee.Mutations.Form.EMPLOYEE_CHANGE] (state, payload) {
    state.newEmployee[payload.attribute] = payload.value;
  },

  [NewEmployee.Mutations.Form.RELATIONSHIP_CHANGE] (state, payload) {
    state.newEmployeeEmploymentRelationship[payload.attribute] = payload.value;
  },

  [NewEmployee.Mutations.Form.DETAIL_CHANGE] (state, payload) {
    state.newEmployeeEmploymentRelationshipDetail[payload.attribute] = payload.value;
  },

  [NewEmployee.Mutations.SET_POLICY_PARTICIPATIONS] (state, payload) {
    let policyParticipations = [];
    payload.policies.filter(p => p.isActiveOnDate(state.newEmployeeEmploymentRelationship.fromDate)).forEach(p => {
      let participation = new PolicyParticipation({
        policyNumber: p.policyNumber,
        fromIsoDate: state.newEmployeeEmploymentRelationship.fromDate,
        untilIsoDate: state.newEmployeeEmploymentRelationship.untilDate
      });

      let participationDetail = new PolicyParticipationDetail({
        fromIsoDate: state.newEmployeeEmploymentRelationship.fromDate,
        untilIsoDate: state.newEmployeeEmploymentRelationship.untilDate,
        hasWaiver: false
      });

      participation.policyParticipationDetails.push(participationDetail);
      policyParticipations.push(participation);
    });

    state.newEmployee.allParticipations = policyParticipations;
  },

  [NewEmployee.Mutations.CLEAR] (state) {
    state.newEmployee = new Employee();
    state.newEmployeeEmploymentRelationship = new EmploymentRelationship();
    state.newEmployeeEmploymentRelationshipDetail = new EmploymentRelationshipDetail({
      noRisk: false
    });
    state.newEmployeePolicyParticipations = [];
  },

  [App.Mutations.CLEAR] (state) {
    state.newEmployee = new Employee();
    state.newEmployeeEmploymentRelationship = new EmploymentRelationship();
    state.newEmployeeEmploymentRelationshipDetail = new EmploymentRelationshipDetail({
      noRisk: false
    });
    state.newEmployeePolicyParticipations = [];
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
